<script setup lang="ts">
import TagItem from './TagItem.vue'

import type { StructureTermTreeParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  tagList: StructureTermTreeParagraph['structureTermTree']
}>()
</script>

<template>
  <div class="bx-content bx-tag-list__wrapper bx-typo--tag-list">
    <ul class="bx-tag-list bx-tag-list--level-0">
      <TagItem v-for="item in tagList"
               :key="item.id"
               :tag-item="item"
               :level="1" />
    </ul>
  </div>
</template>
